<template>
  <div class="users-page">
    <!-- 标签筛选下拉按钮 -->
    <div class="filter-header">
      <div class="filter-tag-btn" @click="showTagPopup = true">
        根据标签筛选 
        <van-icon name="arrow-down" class="filter-icon"/>
      </div>
    </div>
    
    <!-- 标签选择弹出层 - 在users-page容器内显示 -->
    <div v-if="showTagPopup" class="tag-popup-overlay-inside">
      <div class="tag-popup-content-inside">
        <div class="tag-popup-header">
          <h3>选择标签</h3>
          <van-icon name="cross" class="close-icon" @click="showTagPopup = false"/>
        </div>
        <div class="tag-popup-body">
          <SelectLabels :label-categories="labelCategories" @tags-selected="handleTagsSelected" />
        </div>
        <div class="tag-popup-footer">
          <van-button type="primary" @click="confirmTagSelection">确定</van-button>
        </div>
      </div>
    </div>

    <div class="table-header">
      <div class="checkbox-col">
        <van-checkbox v-model="isAllSelected" @click="handleSelectAll">客户</van-checkbox>
      </div>
      <div class="description-col">描述</div>
      <div class="time-col">时间</div>
    </div>

    <div class="user-list">
      <div v-if="filteredUsers.length > 0">
        <van-checkbox-group v-model="result" ref="checkboxGroup" @change="onCheckboxGroupChange">
          <div v-for="user in filteredUsers" :key="user.id" class="user-item">
            <div class="checkbox-col">
              <van-checkbox :name="user.user_id">
                <div class="user-info">
                  <img :src="user.avatar" alt="头像" class="user-avatar" />
                  <span class="user-name">{{ user.name }}</span>
                </div>
              </van-checkbox>
            </div>
            <div class="description-col">{{ user.description }}</div>
            <div class="time-col">{{ user.addTime }}</div>
          </div>
        </van-checkbox-group>
      </div>
      <div v-else class="empty-state">
        <p>标签下暂无用户数据</p>
      </div>
    </div>

  </div>
</template>

<script>
import { getUserListByLabel } from "../../api/robot.js";
import { Toast } from "vant";
import { mapActions } from "vuex";
// 导入标签选择组件
import SelectLabels from './components/selectLabels.vue';
export default {
  props: {
    labelCategories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 选中的用户ID列表
      result: [],
      // 用户列表数据
      users: [],
      // 显示标签选择弹出层
      showTagPopup: false,
      // 当前选择的标签ID
      currentTagIds: '',
      selectedTags:[]
    };
  },
  components: {
    SelectLabels
  },
  created() {
    this.initUserList();
  },
  computed: {
    // 用户列表直接使用原始数据，不进行过滤
    filteredUsers() {
      return [...this.users];
    },
    // 计算是否所有项都被选中
    isAllSelected: {
      get() {
        return this.filteredUsers.length > 0 && this.result.length === this.filteredUsers.length;
      },
      set(val) {
        // 这个setter不会被直接调用，因为我们通过handleSelectAll方法来处理点击事件
      }
    }
  },
  methods: {
    ...mapActions('robot', ['setSelectedUserIds']),
    
    // 处理标签选择事件
    handleTagsSelected(selectedTags) {
      this.selectedTags = selectedTags;
    },
    
    // 确认标签选择
    confirmTagSelection() {
      // 关闭弹出层
      this.currentTagIds = this.selectedTags.join(',');
      this.selectedTags = []
      this.showTagPopup = false;
      
      this.initUserList();
    },

    closePage() {
      // 找到父组件（labels.vue）并调用其方法关闭用户组件
      // 通过$parent链找到labels组件
      let parent = this.$parent;
      while (parent && !parent.showUserComponent) {
        parent = parent.$parent;
      }
      // 如果找到了包含showUserComponent的父组件，则隐藏用户组件
      if (parent && typeof parent.showUserComponent !== 'undefined') {
        parent.showUserComponent = false;
      }
    },

    initUserList() {
      // 使用当前选择的标签ID，默认为空字符串
      const labelIdsStr = this.currentTagIds;

      getUserListByLabel({
        label_ids: labelIdsStr
      }).then(res => {
        console.log('当前选择的标签ID:', this.currentTagIds);
        if (res.code === 1) {
          const data = res.data.map(user => ({
            ...user,
            name: user.nickname,
            description: user.label_names ? user.label_names.join('、') : '',
            addTime: user.add_customer_time ? this.formatTime(user.add_customer_time) : ''
          }));
          this.users = data;
          // 清空之前的选择
          this.result = [];
        } else {
          Toast.fail(res.msg);
        }
      })
    },
    // 格式化时间
    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${month}-${day}`;
    },

    // 处理全选
    handleSelectAll() {
      // 确保checkboxGroup已经初始化
      if (this.$refs.checkboxGroup) {
        // 根据当前是否全选来切换状态
        if (this.isAllSelected) {
          // 当前是全选状态，点击后取消全选
          this.result = [];
        } else {
          // 当前不是全选状态，点击后全选
          this.result = this.filteredUsers.map(user => user.user_id);
        }
      }
    },

    // 更新全选状态
    updateSelectAllStatus() {
      // 不再需要设置selectAll，直接通过计算属性isAllSelected来控制
    },

    // CheckboxGroup的change事件处理
    onCheckboxGroupChange() {
      this.updateSelectAllStatus();
      // 勾选用户时直接调用setSelectedUserIds
      this.setSelectedUserIds(this.result);
    },
  }
};
</script>

<style scoped lang="less">
.users-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative;
}

/* 标签筛选按钮样式 */
.filter-header {
  padding: var(--base-px-12) var(--base-px-16);
  background-color: #f8f8f8;
  border-bottom: 1px solid #f0f0f0;
}

.filter-tag-btn {
  display: inline-flex;
  align-items: center;
  padding: var(--base-px-6) var(--base-px-12);
  background-color: #fff;
  border: var(--base-px-1) solid #e0e0e0;
  border-radius: var(--base-px-4);
  font-size: var(--base-px-14);
  color: #333;
  cursor: pointer;
}

.filter-icon {
  margin-left: var(--base-px-4);
  font-size: var(--base-px-12);
}

/* 标签选择弹出层样式 - 在users-page容器内显示 */
.tag-popup-overlay-inside {
  position: absolute;
  top: var(--base-px-46);
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

.tag-popup-content-inside {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-radius: 0 0 var(--base-px-8) var(--base-px-8);
  animation: slideDown 0.3s ease;
  max-height: 80%;
  display: flex;
  flex-direction: column;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.tag-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--base-px-16);
  border-bottom: 1px solid #f0f0f0;
}

.tag-popup-header h3 {
  margin: 0;
  font-size: var(--base-px-16);
  font-weight: 500;
  color: #333;
}

.close-icon {
  font-size: var(--base-px-18);
  color: #999;
  cursor: pointer;
}

.tag-popup-body {
  padding: var(--base-px-16);
  flex: 1;
  overflow-y: auto;
}

.tag-popup-footer {
  padding: var(--base-px-16);
  border-top: 1px solid #f0f0f0;
}

.tag-popup-footer .van-button {
  width: 100%;
  border-radius: var(--base-px-4);
}

.tag-popup-footer :deep(.van-button--primary) {
  background-color: #006eff;
  border-color: #006eff;
}



.table-header {
  display: flex;
  padding: var(--base-px-12) var(--base-px-16);
  background-color: #f8f8f8;
  font-size: var(--base-px-14);
  color: #666;
  border-bottom: 1px solid #f0f0f0;
  flex-justify: space-between;
  .checkbox-col {
    flex: 2;
    display: flex;
    align-items: center;
  }

  .description-col {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .time-col {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.user-list {
  flex: 1;
  overflow-y: auto;

  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--base-px-20);
    color: #999;
    font-size: var(--base-px-14);
    font-weight: 400;
  }

  .user-item {
    display: flex;
    align-items: center;
    padding: var(--base-px-12) var(--base-px-16);
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .checkbox-col {
      flex: 2;

      .user-info {
        display: flex;
        align-items: center;

        .user-avatar {
          width: var(--base-px-32);
          height: var(--base-px-32);
          border-radius: 50%;
          margin-right: var(--base-px-8);
        }

        .user-name {
          font-size: var(--base-px-14);
          color: #333;
        }
      }
    }

    .description-col {
      flex: 3;
      font-size: var(--base-px-12);
      color: #666;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      text-align: center;
    }

    .time-col {
      flex: 1;
      text-align: right;
      font-size: var(--base-px-14);
      color: #999;
    }
  }
}


</style>

